const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const pad = value => String(value).padStart(2, '0')

// Numeric chart times already contain the user's display wall clock. Read UTC
// fields to preserve that projection; applying a timezone again shifts the day.
// BusinessDay/string inputs represent session dates, independent of timezone.
function formatChartTime(time, includeTime) {
  let date
  if (typeof time === 'number' && Number.isFinite(time)) date = new Date(time * 1000)
  else if (typeof time === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(time)) date = new Date(`${time}T00:00:00Z`)
  else if (time && [time.year, time.month, time.day].every(Number.isInteger)) date = new Date(Date.UTC(time.year, time.month - 1, time.day))
  if (!date || !Number.isFinite(date.getTime())) return ''
  const label = `${WEEKDAYS[date.getUTCDay()]} ${pad(date.getUTCDate())} ${MONTHS[date.getUTCMonth()]} '${pad(date.getUTCFullYear() % 100)}`
  return includeTime ? `${label} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}` : label
}

const dateLabel = time => formatChartTime(time, false)
const dateTimeLabel = time => formatChartTime(time, true)

export function chartTimeLabelFormatter(timeframe) {
  return ['daily', 'weekly', 'monthly'].includes(timeframe) ? dateLabel : dateTimeLabel
}
